import React, { useState } from "react";
import "./Input.css";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import ReactSelect from "react-select";
import MultiSelect from "react-multi-select-component";

const Input = (props) => {
  const {
    label,
    className,
    labelClassName,
    placeholder,
    value,
    onChange,
    errorMessage,
    showRightIcon,
    isPassword,
    isDropdown,
    isDropdownSelectAll,
    isDate,
    type,
    options,
    isDisabled,
    maxLength,
    id,
    onClick,
    Selectplaceholder,
    isValid,
    isMulti,
    onKeyDown,
    maxDate,
    minDate,
    isClearable,
    optionField,
    adminlabel,
    onInputChange,
  } = props;

  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="d-flex flex-column w-100 gap-1">
      {!adminlabel && (
        <label className={`${labelClassName || "Label_Font"}`}>
          {label}{" "}
          {optionField ? (
            <span className="optionalDropds">(optional)</span>
          ) : (
            <code>*</code>
          )}
        </label>
      )}

      {isDropdown ? (
        <ReactSelect
          value={value === "" ? null : value}
          onChange={onChange}
          className="Dropdown_Back_Color"
          options={options}
          isMulti={isMulti}
          isDisabled={isDisabled}
          placeholder={Selectplaceholder}
          isClearable={isClearable}
          onInputChange={(inputValue) => {
            if (onInputChange) onInputChange(inputValue);
          }}
          theme={(theme) => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary25: "#237E85",
              primary: "#237E85",
            },
          })}
        />
      ) : isDropdownSelectAll ? (
        <MultiSelect
          value={value || []}
          onChange={onChange}
          className="Dropdown_Back_Color"
          options={options}
          disabled={isDisabled}
          labelledBy={Selectplaceholder}
        />
      ) : (
        <div className="position-relative d-flex flex-row">
          <input
            disabled={isDisabled}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            id={id}
            onClick={onClick}
            maxLength={maxLength}
            max={maxDate}
            min={minDate}
            onKeyDown={onKeyDown}
            autoComplete="off"
            className={`w-100 Input_Style Input_Back_Color ${className}`}
            type={
              isPassword
                ? showPassword
                  ? "text"
                  : "password"
                : isDate
                ? "date"
                : type || "text"
            }
          />

          {(isPassword || showRightIcon) && (
            <div
              onClick={() => setShowPassword(!showPassword)}
              className="position-absolute cursor-pointer"
              style={{
                right: 10,
                top: "15%",
              }}
            >
              {showRightIcon ? (
                showRightIcon
              ) : showPassword ? (
                <AiOutlineEye size={20} />
              ) : (
                <AiOutlineEyeInvisible size={20} />
              )}
            </div>
          )}
        </div>
      )}

      <div className="err-msg-false">{errorMessage}</div>
      {/* Optionally use:
          <div className={isValid ? "err-msg-true" : "err-msg-false"}>
            {errorMessage}
          </div>
      */}
    </div>
  );
};

Input.defaultProps = {
  value: "",
  id: "",
  maxLength: "",
  onChange: () => {},
  onClick: () => {},
  errorMessage: "",
  label: "",
  placeholder: "",
  showRightIcon: null,
  isPassword: false,
  optionField: false,
  isDropdown: false,
  isDropdownSelectAll: false,
  options: [],
  isDisabled: false,
  isClearable: false,
  adminlabel: false,
  labelClassName: "",
  className: "",
  Selectplaceholder: "",
  maxDate: "",
  minDate: "",
  isValid: null,
  isMulti: false,
  onInputChange: null,
};

export default Input;
